import store from "@/store";
import * as types from "@/store/constants/types";
import GeneralUtilsHelper from "@/utils/generalUtils";
import localStorageHelper from "@/localstorage/localstorage";
import router from "@/router/router"

class LimitCoinFnc {
  private setTimeoutTimer: any = null;
  private initTime = 0;
  private delayTime = 0;
  private limitCoin: any;
  private intervalTime = 0;
  private nowTimeStamp = 0;
  private transaction_time = 0;
  private initialInterval = 0;
  private durationTime = 0;
  private chanceInterval = 0;
  private commomInterval = 0;

  public isShowlimiteCoin() {
    clearInterval(this.setTimeoutTimer);
    this.getTransotionTime();
    this.isShowLimitCoin();
    console.log('this. delaytime inter',this.delayTime,this.intervalTime)
    if(this.delayTime <= 0) {
      this.handleShow()
    } else {
      store.commit(types.UPDATE_LIMITED_COIN_SHOW,false);
      store.commit(types.UPDAE_LIMITED_COIN_BUBBLE_STATUS,false);
      this.setTimeoutTimer = setTimeout(() => {
        this.handleShow()
      },this.delayTime)
    }
  }
  private handleShow() {
    store.commit(types.UPDATE_LIMITED_COIN_INTERVAL_TIME,this.intervalTime);
    localStorageHelper.set('last_limit_coin_end',new Date().valueOf()+this.intervalTime*1000);
    if(this.intervalTime > 0) {
      if(GeneralUtilsHelper.isHalfCoins() || GeneralUtilsHelper.isDoubleCoins()) {
        store.commit(types.UPDATE_LIMITED_COIN_SHOW,false)
      } else {
        store.commit(types.UPDATE_LIMITED_COIN_SHOW,true);
      }
      if(this.isCanShowLimitCoinBubble()) {
        store.commit(types.UPDAE_LIMITED_COIN_BUBBLE_STATUS,true)
      } else {
        store.commit(types.UPDAE_LIMITED_COIN_BUBBLE_STATUS,false);
      }
    } else {
      store.commit(types.UPDATE_LIMITED_COIN_SHOW,false)
      store.commit(types.UPDAE_LIMITED_COIN_BUBBLE_STATUS,false);
    }
  }
  private isCanShowLimitCoinBubble() {
    const path = router.history.current.path;
    const isTabThreeFour =  path ? (path.includes('/Home/EarnCoin') || path.includes('/Home/CoinsContainer')) : false;
    if(isTabThreeFour || GeneralUtilsHelper.isDoubleCoins() || GeneralUtilsHelper.isHalfCoins()) {
      return false;
    } else {
      return true;
    }
  }

  private isShowLimitCoin() {
    this.initTime = store.getters[types.INITIAL_TIME_STAMP];
    this.limitCoin = store.getters[types.GETTER_SETTING_DATA].limited_coin;
    this.initialInterval = this.limitCoin.limited_coinoffer_initial_interval*1000;
    this.durationTime = this.limitCoin.limited_coinoffer_duration;
    this.commomInterval = this.limitCoin.limited_coinoffer_interval*1000;
    this.chanceInterval = this.limitCoin.limited_coinoffer_chance_interval*1000;
    this.nowTimeStamp = new Date().valueOf();
    store.commit(types.UPDATE_LIMITED_COIN_INTERVAL_TIME,-1);
    const lastLimitCoinEnd = localStorageHelper.get('last_limit_coin_end');
    console.log('lastlimtedcoin',lastLimitCoinEnd,'transition',this.transaction_time,'nowtime',this.nowTimeStamp)
    //存在lastlimitcoinend，代表之前有显示过limit coin
    if(lastLimitCoinEnd) {
      //上次买limit coin的时间
      if(this.transaction_time) {
        if(this.nowTimeStamp >= this.transaction_time + this.chanceInterval) {
          if(this.nowTimeStamp < lastLimitCoinEnd) {
            this.intervalTime   = Math.floor((lastLimitCoinEnd - this.nowTimeStamp)/1000);
            this.delayTime = 0;
          } else if(this.nowTimeStamp - lastLimitCoinEnd < this.commomInterval) {
            this.intervalTime = this.durationTime;
            this.delayTime = lastLimitCoinEnd + this.commomInterval - this.nowTimeStamp
          } else {
            this.intervalTime = this.durationTime;
            this.delayTime = 0;
          }
        } else {
          this.intervalTime = this.durationTime;
          this.delayTime = this.transaction_time+this.chanceInterval - this.nowTimeStamp;
        }
      } else {
        //之前没买过 limited coin；
        //上次循环还未结束
        if(this.nowTimeStamp < lastLimitCoinEnd) {
          this.intervalTime = (lastLimitCoinEnd - this.nowTimeStamp)/1000;
          this.delayTime = 0;
        } else if(this.nowTimeStamp - lastLimitCoinEnd >= this.commomInterval) { //立即开始第二次循环
          this.intervalTime = this.durationTime;
          this.delayTime = 0;
        } else { //延迟进行第二次循环
          this.intervalTime = this.durationTime;
          this.delayTime = lastLimitCoinEnd + this.commomInterval - this.nowTimeStamp;  
        }
      }
    } else {
      // 第一次循环
      const timeStamp= this.nowTimeStamp - this.initTime; 
      this.intervalTime = this.durationTime;    
      if(timeStamp > this.initialInterval) {
        this.delayTime = 0;
      } else {
        this.delayTime = this.initialInterval - timeStamp;
      }
    }
  }

  private getTransotionTime() {
    const purchasedOffer = store.getters[types.GETTER_PURCHASED_OFFER];
    for (const j of purchasedOffer) {
      if (j.offer_id === store.getters[types.GETTER_SETTING_DATA].limited_coin_offers[0].offer_id) {
        this.transaction_time = j.transaction_time;
      }
    }
  }
}

const limitCoinFnc = new LimitCoinFnc();
export default limitCoinFnc;
